/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneBase from 'base/components/standalone/Base';

export const DynamicStandaloneBase = StandaloneBase;
export type DynamicStandaloneBaseProps = PropsFromComponent<typeof StandaloneBase>;

export const DynamicStandaloneBaseWith = (extras: DynamicStandaloneExtras): typeof StandaloneBase => {
    return function DynamicStandaloneBase(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Base');
        return <StandaloneBase {...mergeProps({ options: { theme } }, props)} />;
    }
}